import {
    parseDateToStartOfDayIsoWithTimezone,
    formatIsoToLocalDateString,
} from '@core/utils/dateTimezone';

export const dateFilterInputProps = {
    parse: parseDateToStartOfDayIsoWithTimezone,
    format: formatIsoToLocalDateString,
};
